module.exports = __webpack_public_path__ + "img/slide06.d5bac1df.jpg";